/** @format */

import { AvailabilityMessage, ProductAvailability } from '@shared/data-access/interfaces';
import { Component, Input, OnChanges, input } from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconSignCircledCancelFilled,
	homefieldIconSignCircledCheck
} from '@dsg-tech/homefield-angular-icons';
import { PICKUP_MESSAGES, SHIPPING_MESSAGES } from '@shared/data-access/constants';

import { CommonModule } from '@angular/common';
import { HmfActionTextComponent } from '@dsg-tech/homefield-angular';

@Component({
	selector: 'common-product-availability',
	imports: [CommonModule, HmfActionTextComponent, HomefieldIconLibraryModule],
	templateUrl: './product-availability.component.html',
	styleUrl: './product-availability.component.scss'
})
export class ProductAvailabilityComponent implements OnChanges {
	@Input() isComingSoon = false;
	@Input() isOOS = false;
	@Input() productAvailabilityData: ProductAvailability | undefined = undefined;
	selectedStoreName = input('');
	userZipCode = input('');
	showZipCodeAndStoreInMessage = input(false);

	pickupMessage: AvailabilityMessage | undefined = undefined;
	shippingMessage: AvailabilityMessage | undefined = undefined;

	constructor(private readonly homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		this.homefieldIconsLibraryService.registerIcons([
			homefieldIconSignCircledCheck,
			homefieldIconSignCircledCancelFilled
		]);
	}

	ngOnChanges(): void {
		if (this.productAvailabilityData) {
			this.shippingMessage =
				SHIPPING_MESSAGES[this.productAvailabilityData.onlineInventoryMessage];
			this.pickupMessage =
				PICKUP_MESSAGES[this.productAvailabilityData.inStoreInventoryMessage];
		}
	}
}
